import { Component, h } from '@stencil/core';
import state from '../../store';

@Component({
  tag: 'hemfixarna-order',
  shadow: false,
})
export class HemfixarnaOrder {
  resetShop() {
    state.step = 1;
    state.cart = [];
    state.selectedCategory = null;
    state.selectedService = null;
    state.selectedProduct = null;
    state.maleri = null;
    state.checkoutStep = 1;
  }

  disconnectedCallback() {
    this.resetShop();
  }

  render = () => {
    return (
      <div style={{ background: `url(${state.options.thank_you_image})` }} class="hemfixarna_order">
        <div></div>
        <div>
          <h2>{state.checkoutInvoice ? 'Tack för din förfrågan' : 'Tack för din bokning'}</h2>
          {state.checkoutInvoice ? <p>Vi återkommer inom kort till dig på angivet telefonnummer eller epost</p> : null}
          {state.checkoutInvoice ? <div></div> : <hemfixarna-orderrows cart={false}></hemfixarna-orderrows>}
          <span onClick={() => this.resetShop()}>
            <button>Gör en ny bokning</button>
          </span>
          <hemfixarna-info />
        </div>
      </div>
    );
  };
}
